var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CodeEditor',{attrs:{"lang":"xml"},model:{value:(_vm.localValue.html),callback:function ($$v) {_vm.$set(_vm.localValue, "html", $$v)},expression:"localValue.html"}})}
var staticRenderFns = []

export { render, staticRenderFns }